const clerkUserUrlTemplate = process.env.REACT_APP_CLERK_USER_URL_TEMPLATE || '';

const replacePlaceholder = (template: string, placeholder: string, value: string) =>
  template.split(placeholder).join(value);

export const buildClerkUserUrl = (externalUserId?: string | null) => {
  if (!externalUserId || !clerkUserUrlTemplate) {
    return null;
  }
  const encodedUserId = encodeURIComponent(externalUserId);
  const hasPlaceholder =
    clerkUserUrlTemplate.includes('{userId}') ||
    clerkUserUrlTemplate.includes('{externalUserId}');
  if (!hasPlaceholder) {
    return null;
  }
  const withUserId = replacePlaceholder(
    clerkUserUrlTemplate,
    '{userId}',
    encodedUserId,
  );
  return replacePlaceholder(
    withUserId,
    '{externalUserId}',
    encodedUserId,
  );
};
